import { ref, type Ref } from 'vue';

// Bridges a Monaco quick-fix ("Create secret …" on a not-found $__secret squiggle) to the
// app-root NewSecretDialog. The Monaco code action runs in a side-effect lib with no Vue
// component context, so it can't open a dialog directly — it sets a request here and the
// global <NewSecretDialog> in App.vue reacts. Module-level reactive singleton, same
// pattern as lib/realtime.ts and lib/draftRecovery.ts.
export const newSecretRequest: Ref<{ reference: string } | null> = ref(null);

// `reference` is the scope:name the editor flagged as unresolved. The dialog opens
// prefilled with it so the operator sets slot values exactly as in a normal create.
export function requestNewSecret(reference: string): void {
  newSecretRequest.value = { reference };
}

export function clearNewSecretRequest(): void {
  newSecretRequest.value = null;
}
